<template>
  <div class="pc_header_nav">
    <div class="pc_header_nav_box clearfix_">
      <div class="fl pc_header_nav_box_left">
        <div class="pc_header_nav_box_left_list clearfix_">
          <div class="pc_header_nav_box_left_list_item fl">
            <router-link :to="{name:'home'}">首页</router-link>
          </div>
        </div>
      </div>
      <div class="fl pc_header_nav_box_right">
        <div class="pc_header_nav_box_right_list clearfix_">
          <div @mouseenter="hover" @mouseleave="leave" v-show="contact1||contact2" class="pc_header_nav_box_right_list_item fr">
            <div>联系我们</div>
            <div v-show="isContact" class="my_contact">
              <p v-show="contact1">QQ：{{contact1}}</p>
              <p v-show="contact2">电话：{{contact2}}</p>
            </div>
          </div>
          <div @click="refhtml" class="pc_header_nav_box_right_list_item fr">购物车 ( {{cartNum}} )</div>
          <div @click="myorder" class="pc_header_nav_box_right_list_item fr">我的订单</div>
          <div v-show="isLogin" class="pc_header_nav_box_right_list_item fr"><span @click="flushCom">{{userName}}</span> <span @click="signOut">[ 退出 ]</span></div>
          <div v-show="!isLogin" @click="gotoRegistered" class="pc_header_nav_box_right_list_item fr">快速注册</div>
          <div v-show="!isLogin" @click="flushCom" class="pc_header_nav_box_right_list_item fr">你好，请登录</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import axios from 'axios'
    import Qs from 'qs'
    import { ip } from '../../assets/js/public.js'
    import bus from '../../assets/js/eventBus'
    import Cookies from 'js-cookie'
    export default {
        name: "header-nav",
        data(){
          return {
            isLogin:false,
            channel:2,
            userName:"",
            isContact:false,
          }
        },
        mounted:function () {
          this.getTitle()
          this.getLogin()
        },
        computed:{
          cartNum () {
            if(this.$store.state.cartNum == "" || this.$store.state.cartNum == null){
              return this.$store.state.cartNum = 0
            }else {
              return this.$store.state.cartNum
            }
          },
          contact1(){
            return this.$store.state.contact1
          },
          contact2(){
            return this.$store.state.contact2
          },
        },
        methods:{
          go404:function(msg){
            var href=this.$router.resolve({name:'err404',query:{txt:msg}})
            return window.open(href.href,'_blank')
          },
          gotoRegistered:function(){
            this.$router.push({
              name: 'loginHome',
              query: {redirect: this.$route.fullPath,oldRoter:this.$route.path,oldData:this.$route.query,b:2}
            });
          },
          getTitle:function(){
            var t_=this
            var data0bj = Qs.stringify({
              channel:t_.channel,
              tamp:localStorage.tamp?localStorage.tamp:''
            })
            axios.post(`${ip}formWorkInterface/getTenantName`,data0bj).then(res=>{
              if(res.data.code==300)return t_.go404(res.data.message)
              if(res.data.code==0){
                document.title=res.data.name
              }else{
                document.title='电商'
              }
            })
          },
          getLogin:function(){
            var t_=this
            var data0bj = Qs.stringify({
              channel:t_.channel,
              tamp:localStorage.tamp?localStorage.tamp:''
            })
            axios.post(`${ip}formWorkInterface/judgeMember`,data0bj).then(res=>{
              if(res.data.code==300)return t_.go404(res.data.message)
              if(res.data.code==0){
                if(res.data.isLogin==1){
                  t_.isLogin = true
                  t_.getUser();
                  t_.shopcartNum();
                }
                if(res.data.isLogin==2){
                  t_.isLogin = false
                }
              }
            })
          },
          hover:function(){
            this.isContact=true
          },
          leave:function(){
            this.isContact=false
          },
          myorder:function(){
            if(localStorage.tamp){
              var href=this.$router.resolve({name:'order',query:{state:0,listId:0}})
              window.open(href.href,'_blank')
            }else{
              this.$router.push({
                name: 'loginHome',
                query: {redirect: this.$route.fullPath,oldRoter:this.$route.path,oldData:this.$route.query} // 如果你使用钩子函数，your path 可以替换成to.fullPath
              });
            }
          },
          //跳转判断
          refhtml:function () {
            if(localStorage.tamp){
              var href=this.$router.resolve({name:'shopCar'})
              window.open(href.href,'_blank')
            }else {
              this.$router.push({
                name: 'loginHome',
                query: {redirect: this.$route.fullPath,oldRoter:this.$route.path,oldData:this.$route.query} // 如果你使用钩子函数，your path 可以替换成to.fullPath
              });
            }
          },
          getUser:function () {
            if ( localStorage.Items != "undefined" || localStorage.Items != "" || localStorage.Items != null ) {
              this.userName = window.localStorage.getItem("name")
            }
          },
          signOut:function(){
            localStorage.setItem('name','')
            localStorage.setItem('tamp','')
            Cookies.set('name','')
            Cookies.set('tamp', '')
            this.$router.go(0);
          },
          flushCom(){
            if(this.userName){
              var href=this.$router.resolve({name:'member',query:{listId:-1}})
              window.open(href.href,'_blank')
              return
            }else{
              this.$router.push({
                name: 'loginHome',
                query: {redirect: this.$route.fullPath,oldRoter:this.$route.path,oldData:this.$route.query} // 如果你使用钩子函数，your path 可以替换成to.fullPath
              });
            }
          },
          shopcartNum:function () {
            this.$store.commit('ccc')
          }
        }
    }
</script>

<style scoped>
  .pc_header_nav{
    width: 100%;
    height: 35px;
    background: #F5F5F5;
    border-bottom: 1px solid #e5e5e5;
  }
  .pc_header_nav_box{
    width: 1200px;
    height: 35px;
    margin: 0 auto;
  }
  .pc_header_nav_box_left{
    width: 50%;
    height: 35px;
  }
  .pc_header_nav_box_left_list_item{
    line-height: 35px;
    cursor: pointer;
    padding: 0 10px;
  }
  .pc_header_nav_box_left_list_item:hover{
    color: #ffaa00;
  }
  .pc_header_nav_box_right{
    width: 50%;
    height: 35px;
  }
  .pc_header_nav_box_right_list{
    position: relative;
  }
  .pc_header_nav_box_right_list_item{
    line-height: 35px;
    cursor: pointer;
    padding: 0 10px;
  }
  .pc_header_nav_box_right_list_item:hover{
    color: #ffaa00;
  }
  .my_contact{
    padding: 20px;
    background:#fff;
    color:#333;
    position: absolute;
    right: -55px;
    top:46px;
  }
  .my_contact p{
    margin-bottom: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/index/headerNav.vue